import React from 'react';
interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circle' | 'rect';
}
export function Skeleton({
  className = '',
  variant = 'text'
}: SkeletonProps) {
  const baseClasses = 'animate-pulse bg-surface-warm';
  const variantClasses = {
    text: 'h-4 rounded',
    circle: 'rounded-full',
    rect: 'rounded-md'
  };
  return <div className={`${baseClasses} ${variantClasses[variant]} ${className}`} data-id="element-1101" />;
}
interface SkeletonRowProps {
  selectable?: boolean;
  columns?: number;
}
export function SkeletonRow({
  selectable = false,
  columns = 3
}: SkeletonRowProps) {
  return <tr className="border-b border-border bg-white" data-id="element-1102">
      {selectable && <td className="px-4 py-4 w-12" data-id="element-1103">
          <Skeleton variant="rect" className="w-4 h-4" data-id="element-1104" />
        </td>}
      <td className="px-4 py-4" data-id="element-1105">
        <Skeleton variant="text" className="w-32 mb-2" data-id="element-1106" />
        <Skeleton variant="text" className="w-24 h-3" data-id="element-1107" />
      </td>
      <td className="px-4 py-4" data-id="element-1108">
        <Skeleton variant="text" className="w-20" data-id="element-1109" />
      </td>
      <td className="px-4 py-4" data-id="element-1110">
        <Skeleton variant="rect" className="w-16 h-5 rounded-full" data-id="element-1111" />
      </td>
      {Array.from({
      length: columns
    }).map((_, i) => <td key={i} className="px-4 py-4" data-id="element-1112">
          <Skeleton variant="circle" className="w-3 h-3" data-id="element-1113" />
        </td>)}
    </tr>;
}